// extracted by mini-css-extract-plugin
module.exports = {"documents":"developer-api_documents__LFCkN","buyPlanBtn":"developer-api_buyPlanBtn__2FnpY"};